<template>
    <Mub class="breadcrumbs-brabbit-container" id="breadcrumbs" :rawData="mub">
        <a v-if="pageLoaded && (links && links.length)" v-for="(link) in links" :href="link.url">
            <span> {{ link.txt }} </span>
            <i v-if="totalItems != link.pos" class="prz-chevron-right"/>
        </a>
        <div v-if="!pageLoaded" class="fake-bc">
            <div class="skeleton-box"/>
            <div class="skeleton-box"/>
            <div class="skeleton-box"/>
            <div class="skeleton-box"/>
        </div>
    </Mub>
</template>

<script>

import Mub from "@/components/Mub";

export default {
    name: 'Breadcrumbs',
    components: {
        Mub
    },
    props: {
        mub: Object,
        links: {
            type: Array,
            default: null
        },
        pageLoaded: {
            type: Boolean,
            default: false
        }
    },
    created() {
    },
    data() {
        return {}
    },
    watch: {},
    methods: {},
    computed: {
        totalItems() {
            return this.links ? this.links.length : 0;
        }
    },
}
</script>

<style lang="scss">
//@import "./styles/pdpGrid";
@import '../../../scss/CalcSize.scss';
.breadcrumbs-brabbit-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
    width: 100%;

    i {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: responsive(10px);
        margin: 0 responsive(5px);
    }

    a {
        display: flex;
        align-items: center;
        font-size: responsive(12px);
        line-height: 1.167;
        color: #6F6F6F;
        font-weight: 400;
        text-decoration: none;
    }

    .fake-bc {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        height: responsive(15px);
        gap: responsive(20px);

        .skeleton-box {
            width: 150px;
            height: 100%;
            border-radius: 20px;
        }
    }
}
</style>
